import React from 'react';
import { connect } from 'react-redux';
import LineChart from 'components/common/charts/linechart';
//import Modal from "components/common/modal";
export class LineChartContainer extends React.Component {

    getLabels() {
        if (this.props.stats.constraint.startdate == this.props.stats.constraint.enddate) {
            return this.props.stats.points.map((point) => { return point.time.substr(0, 2); });
        }

        else if (this.props.stats.constraint.groupby == 'month') {
            return this.props.stats.points.map((point) => { return point.time.substr(0, 8); });
        }
        else {
            return this.props.stats.points.map((point) => { return point.time.substr(0, 11); });
        }
    }

    getAverage() {
        return this.props.stats.points.map((point) => { return Math.round(point.avg * 100); });
    }

    getPeak() {
        let max = 0;
        if (this.props.stats.constraint.startdate == this.props.stats.constraint.enddate) {
            return this.props.stats.points.map((point) => {
                max = Math.round(point.pk * 100) > max ? Math.round(point.pk * 100) : max;
                return max;
            });
        }
        else {
            return this.props.stats.points.map((point) => { return Math.round(point.pk * 100); });
        }
    }


    render() {
        let data = {};
        data.labels = this.getLabels();
        data.avgs = this.getAverage();
        if (this.props.showPeak) {
            data.peaks = this.getPeak();
        } else {
            data.peaks = [];
        }
        return (
            <div className="stats-card">
                <div className="box--shadow bg--white card__graph" ref={(e) => { document.charts.totalOccupancy = e }} >
                    <div className="clearfix graph__header">
                        <div className="graph__header__title col-sm-offset-3 col-sm-6 clearfix">
                            <h2>Total {this.props.tag}</h2>
                        </div>
                        <div className="graph__header__options clearfix">
                            {/* <Modal
                            disableCloseButton={true}
                            ref={(elem) => { this.openInfoModal = elem }}
                            clickButton={() => { this.openInfoModal.close(); }}
                            header="Info Modal"
                            buttonText="Got it"
                            buttonClass="btn-success"
                            entry={
                                <div className="pull-right header__options__child">
                                    <div onClick={() => { this.openInfoModal.open() }}>
                                        <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                    </div>
                                </div>
                            }
                        >
                            <p>Total Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                        </Modal>
                        */}
                        </div>
                    </div>
                    <div className="graph__body">
                        <LineChart id="totalOccupancy" stats={data} />
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        stats: state.statsReducer.stats
    };
}

export default connect(mapStateToProps, null)(LineChartContainer);


// WEBPACK FOOTER //
// ./src/components/pages/stats/totaloccupancy/linechartcontainer.jsx